.cardBottomFull {
  flex-direction: row;
  width: 100%;
  padding: 0 16px;
  min-width: 162px;

  @media (--reefer-media-tablet-min) {
    gap: 12px;
  }
}

.imageBottom,
.modal {
  flex-direction: row;
  height: 40px;
  width: 96px;

  & > .quantityIcon {
    height: 40px;
    width: 40px;
  }
}

.imageTop {
  flex-direction: column-reverse;
  width: 40px;
  height: min-content;

  & > .quantityIcon {
    height: 40px;
    width: 40px;
  }
}

@media (--reefer-media-tablet-min) {
  .imageBottom_medium,
  .imageBottom_large {
    height: 48px;
    width: 104px;
    padding: 0 16px;
  }

  .modal {
    width: 128px;
  }

  .imageTop_medium,
  .imageTop_large {
    width: 56px;
    padding: 4px 0;
    border-radius: 100px;
  }
}

.updating {
  opacity: var(--opacity-disabled-btn);
  transition: opacity 200ms ease;
}

.centerDisplay {
  display: grid;
  place-items: center;
}

.centerDisplay > * {
  grid-area: 1 / 1;
  transition: opacity 200ms ease;
}

.visible {
  opacity: 1;
}

.hidden {
  opacity: 0;
}

.textContrastColor {
  color: var(--colors-text-inverse);
}

.textDisabledColor {
  color: var(--color-black-transparent-twenty);
}
